module.exports = __webpack_public_path__ + "static/img/ai_robot.74f7b0e9.svg";